import type { DashboardOverview } from "@/api/custom_types";
export const defaultDashboardOverview: DashboardOverview = {
	user_id: "",
	num_of_available_senders: 0,
	num_of_broken_senders: 0,
	global_tax: "",
	snipe_success_ratio: 0,
	debts_to_pay: 0,
	debts_to_receive: 0,
	total_ordered: 0,
	total_delivered: 0,
	top_sellers: [],
};
